"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RLOMode;
(function (RLOMode) {
    RLOMode[RLOMode["login"] = 0] = "login";
    RLOMode[RLOMode["signup"] = 1] = "signup";
})(RLOMode = exports.RLOMode || (exports.RLOMode = {}));
var WixViewMode;
(function (WixViewMode) {
    WixViewMode["PREVIEW"] = "preview";
    WixViewMode["EDITOR"] = "editor";
    WixViewMode["SITE"] = "site";
})(WixViewMode = exports.WixViewMode || (exports.WixViewMode = {}));
//# sourceMappingURL=js-sdk.js.map